export const DefaultCsvConfiguration = {
    enableMultipleTableSchema: false,
};
export class CsvConfigurator {
    static KEY = "csv";
    static getFromObject(configurationObject) {
        return configurationObject?.[CsvConfigurator.KEY] ?? {};
    }
    static setToObject(configurationObject, options) {
        return { ...configurationObject, [CsvConfigurator.KEY]: options };
    }
    static merge(...options) {
        let result = {};
        for (const option of options) {
            result = { ...result, ...option };
        }
        return result;
    }
    static getDefault() {
        return DefaultCsvConfiguration;
    }
}
//# sourceMappingURL=configuration.js.map